import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from "../services/auth.service";
import {environment} from "../../environments/environment.development";

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Прикрепляем токен только к запросам на собственный API,
    // чтобы не допустить утечки токена на сторонние домены.
    if (!request.url.startsWith(environment.apiBase)) {
      return next.handle(request);
    }

    // API-ключ шлём всегда — базовый фильтр ботов на бэке.
    const apiHeaders = request.headers
      .append('X-Api-Key', environment.apiKey);
    request = request.clone({headers: apiHeaders});

    const user = this.auth.getUserFromStorage();
    if (!user?.token) {
      // Анонимный запрос — пропускаем без заголовка авторизации.
      return next.handle(request);
    }

    // Не отправляем истёкший токен (isTokenExpired при необходимости делает logout).
    if (this.auth.isTokenExpired()) {
      return next.handle(request);
    }

    const headers = request.headers
      .append('Authorization', 'Bearer ' + user.token);

    return next.handle(request.clone({headers}));
  }
}
